export function browserUnsupported() {
  return !CSS.supports('selector(:has(a))');
}
